import { SafePromise } from '@benzinga/safe-await';
import { Subscribable, Subscription } from '@benzinga/subscribable';
import { MarketingWinsRequest, MarketingWinsRequestEvent, MarketingWinsRequestParams } from './request';
import { Session } from '@benzinga/session';
import { MarketingWin } from './entities';

export type MarketingWinsManagerEvent = MarketingWinsRequestEvent;

export class MarketingWinsManager extends Subscribable<MarketingWinsManagerEvent> {
  private request: MarketingWinsRequest;
  private requestSubscription?: Subscription<MarketingWinsRequest>;

  constructor(session: Session) {
    super();
    this.request = new MarketingWinsRequest(session);
  }

  public static getName = () => 'benzinga-marketing-wins';

  public getWins = async (force?: boolean, params?: MarketingWinsRequestParams): SafePromise<MarketingWin[]> => {
    return await this.request.getWins(force, params);
  };

  protected onSubscribe(_id: number, ..._args: readonly unknown[]) {
    return {
      getWins: this.getWins,
    };
  }
  protected onFirstSubscription() {
    this.requestSubscription = this.request.subscribe(this.dispatch);
  }
  protected onZeroSubscriptions() {
    this.requestSubscription?.unsubscribe();
  }
}
